module.exports = __webpack_public_path__ + "img/img-690acf.png";